export const HYGRAPH_DASHBOARD_POPUP_LIST_ID = 'cmazldmp312ao07k379yxepfi' as const;
export const HYGRAPH_MATCHES_POPUP_LIST_ID = 'cme6suvpbv7hj07lg64bwftuq' as const;
export const HYGRAPH_MESSAGES_POPUP_LIST_ID = 'cme75leha493t07jzy7comt3w' as const;

export const getPopupListQuery = (id: string) => `
  query popupList($id: ID = "${id}") {
    popupList(where: {id: $id}) {
      id
      popups(first: 500) {
        id
      }
    }
  }
`;
